import { proxy } from 'valtio'

export type DayAheadBidEditorMode = 'table' | 'modal'

type DayAheadBidModeStore = {
  mode: DayAheadBidEditorMode
}

/**
 * Which of the two day-ahead bid editors the operator last chose.
 *
 * A store rather than `useState` because the choice has to survive two unmounts it would otherwise
 * be lost to: `DayAheadTradingView` renders one tab at a time and unmounts the other, and the
 * scenario `Tabs` atom keys its body by the active index, so it remounts its child on every
 * scenario change. Local state would send the operator back to the modal editor on each of those.
 *
 * One mode for every day-ahead bid surface, deliberately: the choice is how this operator wants to
 * enter bids, not a property of the tab they are standing on, so it follows them between surfaces.
 */
export const dayAheadBidModeStore = proxy<DayAheadBidModeStore>({
  mode: 'table',
})

export function setDayAheadBidMode(mode: DayAheadBidEditorMode): void {
  dayAheadBidModeStore.mode = mode
}

export function resetDayAheadBidMode(): void {
  dayAheadBidModeStore.mode = 'table'
}
